import { render, staticRenderFns } from "./basic-layout.vue?vue&type=template&id=3b97864e&scoped=true&"
import script from "./basic-layout.vue?vue&type=script&lang=js&"
export * from "./basic-layout.vue?vue&type=script&lang=js&"
import style0 from "./basic-layout.sass?vue&type=style&index=0&id=3b97864e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b97864e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/goeatBackup/goeat-backup-goeat-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
